// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"272":"560b2add","328":"ce7b7ba4","348":"e9d51bfe","384":"ac100567","453":"4583b0f3","504":"452b9644","541":"6adbf3e1","610":"e7fc5c6a","622":"4fa8c1e0","660":"12145933","676":"c055d84c","796":"ba8597ef","797":"23e722d1","871":"82a00e75","885":"7bde7992","954":"3df10955"}[chunkId] + ".chunk.js";
};